'use client';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Date from '@icons/Date.svg';

import { Label } from '@components/Common';
import { DAYS, DaySelectionPanelProps } from '@components/DaySelectionPanel/interfaces';
import {
  DaySelectionContainer,
  DaySelectionItem,
  DaySelectionSection,
  PanelContainer,
} from '@components/DaySelectionPanel/styles';
import { CheckboxWrapper, CustomCheckbox, HiddenCheckbox, Text } from '@components/TermsCheckbox';

/**
 * Day selection panel component to specify availability
 */
export const DaySelectionPanel = ({ selectedDays, onToggleDay }: DaySelectionPanelProps) => {
  const { t } = useTranslation('common');

  return (
    <DaySelectionSection>
      <Label>{t('availability')}</Label>
      <PanelContainer>
        {DAYS.map((day) => {
          const isChecked = selectedDays[day];
          return (
            <DaySelectionContainer key={day}>
              <DaySelectionItem>
                <Date />
                <Text>{t(`days.${day}`)}</Text>
              </DaySelectionItem>
              <CheckboxWrapper>
                <HiddenCheckbox
                  type="checkbox"
                  id={day}
                  checked={isChecked}
                  onChange={() => onToggleDay(day)}
                  required
                  name={day}
                />
                <CustomCheckbox />
              </CheckboxWrapper>
            </DaySelectionContainer>
          );
        })}
      </PanelContainer>
    </DaySelectionSection>
  );
};
